import type { ReceiptTemplate } from '../schema';

export const makeAWishTemplate: ReceiptTemplate = {
  id: 'make-a-wish',
  name: 'Make-A-Wish Receipt',
  brand: 'MAKE-A-WISH',
  description: 'Make-A-Wish donation receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'maw-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'MAKE-A-WISH',
        businessNameFontSize: 16,
        addressLines: ['FOUNDATION', 'DONATION RECEIPT'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'maw-donor',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'donor', label: 'Donor:', value: 'John Doe' },
          { id: 'receipt', label: 'Receipt #:', value: 'MAW-847291034' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'type', label: 'Type:', value: 'One-Time' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'maw-amount',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'donation', label: 'DONATION', value: '100.00', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'maw-tax',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'left', message: 'TAX-DEDUCTIBLE DONATION\nEIN: 86-0481941\n\nNo goods or services were\nprovided in exchange for\nthis contribution.', fontSize: 12, showDivider: true, dividerStyle: 'dashed', isBold: false },
    },
    {
      id: 'maw-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'THANK YOU FOR\nGRANTING WISHES', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: true },
    },
  ],
  updatedAt: new Date().toISOString(),
};

